import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { error } from '@rxweb/reactive-form-validators';
import { AutoLabelPipe } from 'app/shared/pipes/auto-label.pipe';
import { FormErrorsPipe } from 'app/shared/pipes/form-errors.pipe';

@Component({
    selector: 'upsc-form-errors',
    templateUrl: './form-errors.component.html',
    styleUrls: ['./form-errors.component.scss'],
    standalone: true,
    providers: [],
    imports: [
        CommonModule,
        FormErrorsPipe,
        AutoLabelPipe,
    ],
})
export class FormErrorsComponent {
    @Input() public control: AbstractControl;
    @Input() public errorKeyPrefix = '';
    @Input() public labelMapper: { [key: string]: string } = {};
    @HostBinding('class') public hostClass = 'form-errors';
    protected readonly Object = Object;
    protected readonly error = error;
}
